import React from 'react'
import PropTypes from 'prop-types'

const VideoIcon = ({ customClassName, width, height, fill, }) =>
  (<svg
    className={customClassName}
    width={width}
    height={height}
    aria-labelledby="Video"
    viewBox="0 0 79 79"
  >
    <title id="video-icon">Video</title>
    <g>
      <path
        fill={fill}
        d="M0,44.866v20.008c0,4.685,4.312,8.115,8.996,8.115h41.008c4.685,0,7.996-3.431,7.996-8.115v-0.268l15.1,7.501
    			c0.28,0.142,0.464,0.215,0.777,0.215c2.943,0,5.123-2.396,5.123-5.454V40.976c0-3.058-2.055-5.452-4.998-5.452
    			c-0.312,0-0.494,0.073-0.773,0.213L58.284,43.28c-0.722-3.802-3.95-6.705-7.913-6.89c4.167-3.066,6.903-7.989,6.903-13.548
    			c0-9.28-7.541-16.831-16.822-16.831c-7.581,0-13.998,5.042-16.097,11.946c-2.309-2.322-5.501-3.764-9.027-3.764
    			c-7.024,0-12.738,5.715-12.738,12.738c0,3.867,1.489,7.331,4.219,9.669C3.055,37.481,0,40.848,0,44.866z M74.121,39.577
    			C74.723,39.76,75,40.387,75,40.976v25.892c0,0.59-0.277,1.218-0.877,1.401L58,60.125V47.678L74.121,39.577z M26.742,32.176
    			c1.039,1.464,2.307,2.813,3.75,3.813h-6.637C25.042,34.989,26.024,33.625,26.742,32.176z M27.63,22.843
    			c0-7.075,5.755-12.831,12.829-12.831c7.075,0,12.83,5.756,12.83,12.831c0,7.073-5.755,12.828-12.83,12.828
    			c-6.016,0-11.063-4.168-12.443-9.764c-0.056-0.693-0.17-1.368-0.333-2.025C27.655,23.538,27.63,23.193,27.63,22.843z
    			 M15.33,18.194c3.97,0,7.324,2.664,8.384,6.296c0.067,0.689,0.185,1.363,0.333,2.026c0.006,0.139,0.021,0.275,0.021,0.416
    			c0,4.818-3.92,8.738-8.738,8.738c-4.819,0-8.739-3.92-8.739-8.738S10.511,18.194,15.33,18.194z M54,64.493
    			c0,2.483-2.013,4.496-4.496,4.496H8.496C6.013,68.989,4,66.976,4,64.493V44.485c0-2.483,2.013-4.496,4.496-4.496h41.008
    			c2.483,0,4.496,2.013,4.496,4.496V64.493z"
      />
    </g>
  </svg>)

VideoIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
  customClassName: PropTypes.string,
}

VideoIcon.defaultProps = {
  width: 20,
  height: undefined,
  fill: 'blue',
  customClassName: '',
}

export default VideoIcon



// WEBPACK FOOTER //
// ./src/components/icons/Video.js